import { getDownloadURL, ref } from "firebase/storage";
import { FC, useContext, useEffect, useState } from "react";
import { FirebaseContext } from "src/helpers/firebase";

type Props = {
  uri: string;
  className?: string;
};

/** Resolves a Storage path to a download URL and renders the native browser audio player. */
export const FirebaseAudio: FC<Props> = ({ uri, className }) => {
  const { storage } = useContext(FirebaseContext);
  const [audioUrl, setAudioUrl] = useState("");

  useEffect(() => {
    const downloadRef = ref(storage, uri);
    getDownloadURL(downloadRef)
      .then((url) => setAudioUrl(url))
      .catch((error) => {
        const notFound = error.code === "storage/object-not-found";
        if (notFound) return;

        console.error(error);
      });
  }, [uri]);

  if (!audioUrl) return null;
  return <audio controls preload="metadata" src={audioUrl} className={className} />;
};
